import React, { Fragment } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';

import baseMultipleChoiseTheme from './MultipleChoise.scss';

class MultipleChoise extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            answer: undefined,
        };
    }

    componentWillMount() {
        this.setInitialAnswer();
    }

    componentWillUnmount() {
        const {
            answer, part, section, setAnswer,
        } = this.state;
        const { correctAnswer, tip, weight } = this.props;

        if (answer !== undefined) {
            setAnswer({
                part,
                section,
                answer: {
                    answer,
                    correct: answer === correctAnswer,
                    tip,
                    weight,
                },
            });
        }
    }

    setInitialAnswer() {
        const { answer, onStateChange } = this.props;

        if (this.state.answer === undefined && typeof answer === 'number') {
            this.setState({
                answer,
            });
            onStateChange(true);
        }
    }

    validState() {
        const { answer } = this.state;

        if (answer === undefined) {
            return 'Gelieve een antwoord te kiezen';
        }

        return null;
    }

    handleClick(answer) {
        const { onStateChange } = this.props;

        this.setState({
            answer,
        });

        onStateChange(this.validState());
    }

    render() {
        const { answer } = this.state;
        const {
            theme,
            question,
            explenation,
            correctAnswer,
            answers,
            sectionId,
        } = this.props;

        let optionsStyle = {};
        let resultStyle = {};

        if (answer !== undefined) {
            optionsStyle = {
                opacity: 0,
                height: 0,
            };

            resultStyle = {
                transform: 'translateY(0px)',
                opacity: 1,
            };
        }
        return (
            <div className="splitview">
                <div className="split-left">
                    <h6 className="question-count">Vraag {+sectionId + 1}</h6>
                    <h2 className="question-heading">{question}</h2>
                </div>
                <div className="split-right">
                    <div className={theme.options} style={optionsStyle}>
                        <h3 className="answer-heading">Kies een antwoord:</h3>
                        <div className={theme.answers}>
                            {answers.map((a, index) => (
                                <div key={a} className="form-check">
                                    <input
                                        className="form-check-input"
                                        id={a}
                                        onClick={() => {
                                            this.handleClick(index);
                                        }}
                                        disabled={answer !== undefined}
                                        checked={answer === index}
                                        type="radio"
                                        value={index}
                                    />
                                    <label
                                        htmlFor={a}
                                        className="form-check-label"
                                    >
                                        {a}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={theme.result} style={resultStyle}>
                        {answer === correctAnswer ? (
                            <Fragment>
                                <h4
                                    className={classnames(
                                        theme.resultHeading,
                                        theme.correct
                                    )}
                                >
                                    <span>
                                        <i className="bol-icon-icon_checkmark" />{' '}
                                        Goed zo!
                                    </span>
                                </h4>
                                <p>
                                    <strong>Jij antwoordde:</strong>{' '}
                                    {answers[answer]}
                                </p>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <h4
                                    className={classnames(
                                        theme.resultHeading,
                                        theme.wrong
                                    )}
                                >
                                    <span>
                                        <i className="bol-icon-icon_cross" />{' '}
                                        Jammer!
                                    </span>
                                </h4>
                                <p>
                                    <strong>Het juiste antwoord is:</strong>{' '}
                                    {answers[correctAnswer]} <br />
                                    <strong>Jij antwoordde:</strong>{' '}
                                    {answers[answer]}
                                </p>
                            </Fragment>
                        )}
                        <p
                            // eslint-disable-next-line
                            dangerouslySetInnerHTML={{
                                __html: explenation,
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default themr('MultipleChoise', baseMultipleChoiseTheme)(MultipleChoise);



// WEBPACK FOOTER //
// ./src/components/questions/MultipleChoise.js